import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import agent from "../../../app/api/agent";
import { ListFilterConfig, ListFilterValue } from "../../../components/list-filter/models";
import PageTitle from "../../../components/page-title/PageTitle";
import { ReflectionReportModel } from "../../reflections/models";
import ReflectionReportContainer from "../../reflections/ReflectionReportContainer";
import { ReportFilterContext } from "../useReportFilter";
import { ADMIN_REPORTS_INITIAL_FILTER_VALUE } from "./initial-filter-value";

const AdminReportsStudentFeedback = () => {
  const { t } = useTranslation();
  const { years, grades, schools, companies } = useContext(ReportFilterContext);
  const filters: ListFilterConfig = useMemo(
    () => [years, companies, schools, grades],
    [years, grades, schools, companies]
  );

  return (
    <>
      <PageTitle title={t("reports.studentReflections")} />
      <ReflectionReportContainer
        filterConfig={filters}
        initialFilterValue={ADMIN_REPORTS_INITIAL_FILTER_VALUE}
        dataResourceFn={dataResourceFn}
      />
    </>
  );
};

const dataResourceFn = (filter?: ListFilterValue): Promise<ReflectionReportModel> => {
  const params: { grade?: string[]; companyIds?: number[]; schoolIds?: number[]; years?: number[] } = {};
  if (Array.isArray(filter?.grade) && filter?.grade.length) {
    params.grade = filter.grade.map((x) => x.value);
  }
  if (Array.isArray(filter?.company) && filter?.company.length) {
    params.companyIds = filter.company.map((x) => x.value);
  }
  if (Array.isArray(filter?.years) && filter?.years.length) {
    params.years = filter.years.map((x) => x.value);
  }
  if (Array.isArray(filter?.school) && filter?.school.length) {
    params.schoolIds = filter.school.map((x) => x.value);
  }

  return agent.Reports.adminFeedback(params);
};

export default AdminReportsStudentFeedback;
